import React, { useEffect, useState } from "react";
import Chatheader from "../chatheader/chatheader";
import { useStateValue } from '../../../../stateprovider';
import "./summaryready.css";
import ready from "../../../../assets/summary-ready.png";
import { useNavigate } from "react-router-dom";


const SummaryReadyComp = () => {

    const [{ }, dispatch] = useStateValue();
    const navigate = useNavigate();

    useEffect(() => {
        dispatch({
            type: "APP_NAV_STATE",
            appnav: false
        });
    }, []);

    return <div className="app_complaint app_extend">
        <Chatheader />
        <div className="app_summaryready_container">
            <img src={ready} alt="pic" className="app_summaryImage"/>
                <svg xmlns="http://www.w3.org/2000/svg" width="291" height="75" viewBox="0 0 291 75" fill="none">
                    <path d="M1 13.3929C1 6.56276 6.62598 1 13.5981 1H277.402C284.374 1 290 6.56275 290 13.3929V38.3929C290 45.223 284.374 50.7857 277.402 50.7857H253.579C249.161 50.7857 245.579 54.3674 245.579 58.7857V61.6071C245.579 68.4372 239.953 74 232.981 74H58.0187C51.0465 74 45.4206 68.4372 45.4206 61.6071V58.7857C45.4206 54.3674 41.8388 50.7857 37.4206 50.7857H13.5981C6.62598 50.7857 1 45.223 1 38.3929V13.3929Z" stroke="#fff" stroke-width="2" fill="#fff" />
                    
                    <text x="50%" y="50%" text-anchor="middle" alignment-baseline="middle" font-size="12" fill="black" class="svg_text">
                        <tspan x="50%" dy="0">Your summary is ready</tspan>
                        <tspan x="50%" dy="1.2em" className="svg_text_bottom">to be viewed</tspan>
                    </text>
                </svg>

                <p>Doctors summary is ready</p>
                <button onClick={()=> navigate("/summary")}>summary note</button>
            
      
        </div>

    </div>
}
export default SummaryReadyComp;